import { render, staticRenderFns } from "./ctmDetail.vue?vue&type=template&id=5da0e1c2&scoped=true&"
import script from "./ctmDetail.vue?vue&type=script&lang=js&"
export * from "./ctmDetail.vue?vue&type=script&lang=js&"
import style0 from "./ctmDetail.vue?vue&type=style&index=0&id=5da0e1c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5da0e1c2",
  null
  
)

export default component.exports